"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _api = require("../api/api");
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  data: function data() {
    return {
      isMaskVisible: true,
      nameIcon: 'el-icon-arrow-down',
      //控制导航箭头
      showWhiteImg: false,
      //是否显示白色的图片
      // 导航栏
      configNav: [{
        name: '首页',
        path: '/home'
        // subItems: [
        //     { link: { path: '/home' }, text: '化工物流生态体系' },
        //     { link: { path: '/home?to=cont-03' }, text: '车货匹配' },
        //     { link: { path: '/home?to=cont-05' }, text: '合作网点' },
        //     { link: { path: '/home?to=cont-06' }, text: '安全管理' },
        //     { link: { path: '/home?to=cont-04' }, text: '增值服务' },
        // ]
      }, {
        name: '解决方案',
        path: '/software',
        subItems: [{
          link: {
            path: '/logistics'
          },
          text: '物流解决方案'
        }, {
          link: {
            path: '/bussiness'
          },
          text: '商务解决方案'
        },
        // { link: { path: '/finance', }, text: '财务统筹', isSecond: true },
        // { link: { path: '/insurance' }, text: '镖局保险', isSecond: true },

        {
          link: {
            path: '/software'
          },
          text: '软件解决方案'
        }
        // { link: { path: '/TMS' }, text: 'TMS-运输管理系统', isSecond: true },
        // { link: { path: '/WMS' }, text: 'WMS-仓储管理系统', isSecond: true },
        // { link: { path: '/wisdom5G', }, text: '5G智慧管控平台', isSecond: true },
        // { link: { path: '/chain', }, text: '数字供应链产品', isSecond: true },
        // { link: { path: '/logisticsPark', }, text: '鑫展旺物流园区', isSecond: true },
        ]
      }, {
        name: '物流联盟',
        path: '/wllm'
        // subItems: [
        //     { link: { path: '/wllm' }, text: '合作愿景' },
        //     { link: { path: '/wllm?to=cont-02' }, text: '加盟条件' },
        //     { link: { path: '/wllm?to=cont-03-01' }, text: '产品赋能' },
        //     { link: { path: '/wllm?to=cont-03-02' }, text: '商业赋能' },
        //     { link: { path: '/wllm?to=cont-04' }, text: '我们的优势' },
        //     { link: { path: '/wllm?to=cont-05' }, text: '赚钱的大联盟' },
        //     { link: { path: '/wllm?to=cont-06' }, text: '省钱的大联盟' },
        //     { link: { path: '/wllm?to=cont-07' }, text: '靠得住的伙伴' },
        //     { link: { path: '/wllm?to=cont-08' }, text: '加入千城联盟' },
        // ]
      }, {
        name: '化工信息',
        path: '/goods',
        subItems: [{
          link: {
            path: '/goods'
          },
          text: '交易大厅'
        }, {
          link: {
            path: '/specialVehicle'
          },
          text: '镖局专车'
        }, {
          link: {
            path: '/chemicalMall'
          },
          text: '化工商城'
        }, {
          link: {
            path: '/waybill'
          },
          text: '电子运单'
        }, {
          link: {
            path: '/msdsList'
          },
          text: 'MSDS'
        }, {
          link: {
            path: '/newslist',
            query: {
              isSearch: false,
              searchVal: '',
              isDetail: false
            },
            params: {
              isSearch: false
            }
          },
          text: '危化头条'
        }, {
          link: {
            path: '/cooperationMall/zpList'
          },
          text: '危化商铺'
        }]
      }, {
        name: '关于我们',
        path: '/aboutus'
        // subItems: [
        //     { link: { path: '/aboutus' }, text: '公司简介' },
        //     { link: { path: '/aboutus?to=culture' }, text: '公司理念' },
        //     { link: { path: '/aboutus?to=honor' }, text: '公司荣誉' },
        //     { link: { path: '/aboutus?to=company' }, text: '合作企业' },
        //     {
        //         link: { path: 'https://www.xmrc.com.cn/net/info/showcojob.aspx?CompanyID=934738', query: { type: 'toRecruit' } },
        //         text: '招贤纳士'
        //     },
        //     { link: { path: '/aboutus?to=contact' }, text: '联系我们' },
        // ]
      }],
      currentNavItem: {},
      //当前移入的导航栏
      navConfig: {
        bgColor: '#fff',
        textColor: '#212121'
      },
      // 导航栏颜色配置

      // 导航栏移入移出定时器
      mouseOvertimer: null,
      mouseLeavetimer: null,
      animationDown: null,
      activeIndex: '1',
      //登录状态菜单
      dialogTgVisible: false,
      //推广弹窗的显示隐藏

      tgImgs: [require("../assets/static/img/qrCode_01.jpg"), require("../assets/static/img/qrCode_02.jpg"), require("../assets/static/img/qrCode_03.jpg"), require("../assets/static/img/qrCode_04.jpg"), require("../assets/static/img/qrCode_05.jpg")],
      qrCodetg: '',
      //推广码
      tgUrl: '' //推广链接
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function handler(val, oldVal) {
        if (val.path == '/home') {
          this.showWhiteImg = true;
          this.navConfig.bgColor = 'transparent';
          this.navConfig.textColor = '#fff';
        } else {
          this.showWhiteImg = false;
          this.navConfig.bgColor = '#fff';
          this.navConfig.textColor = '#212121';
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 推广弹窗随机背景
    backgroundImage: function backgroundImage() {
      // 根据背景图数组的长度随机选择索引
      var randIndex = Math.floor(Math.random() * this.tgImgs.length);
      return {
        // 获取对应的图片资源并将其设置到`background-image`属性上
        backgroundImage: "url(".concat(this.tgImgs[randIndex], ")")
      };
    }
  },
  methods: {
    // 鼠标进入
    mouseenter: function mouseenter(item) {
      var _this = this;
      // console.log(item, "鼠标进入的时候")
      this.mouseOvertimer = setTimeout(function () {
        // console.log('鼠标进入')
        _this.currentNavItem = item;
        if (_this.currentNavItem.subItems) {
          _this.isMaskVisible = true;
          // console.log('给他渲染')
          document.getElementById('mask').className = 'mask show-mask';
          _this.showWhiteImg = false;
          _this.navConfig.textColor = '#212121';
          _this.nameIcon = 'el-icon-arrow-up';
        } else {
          document.getElementById('mask').className = 'mask hide-masktwo';
          _this.navConfig.bgColor = 'transparent';
          _this.$route.name == 'home' ? _this.showWhiteImg = true : _this.showWhiteImg = false;
          _this.$route.name == 'home' ? _this.navConfig.textColor = '#fff' : _this.navConfig.textColor = '#212121';
        }
      }, 200);
      clearInterval(this.mouseLeavetimer);
      clearInterval(this.animationDown);
    },
    // 鼠标离开
    // mouseleave(e) {
    //     clearInterval(this.mouseOvertimer);
    //     this.mouseLeavetimer = setTimeout(() => {
    //         // console.log('鼠标离开', e)
    //         let maskHeight = document.getElementById('mask').offsetHeight
    //         if (e.y >= 0 && e.y < maskHeight) {
    //             // 在导航栏范围内移动的就保持不变
    //             return
    //         } else if (e.y < 0 || e.y >= maskHeight) {
    //             // 超出浏览器范围的 || 超出导航栏范围的 就收起导航栏
    //             document.getElementById('mask').className = 'mask hide-mask'
    //             this.animationDown = setTimeout(() => {
    //                 if (this.$route.name == 'home') {
    //                     this.showWhiteImg = true
    //                     this.navConfig.textColor = '#fff'
    //                 }
    //             }, 500)
    //         }
    //     }, 150)
    // },
    // 鼠标离开
    mouseleave: function mouseleave(e) {
      var _this2 = this;
      clearInterval(this.mouseOvertimer);
      this.mouseLeavetimer = setTimeout(function () {
        var maskHeight = document.getElementById('mask').offsetHeight;
        // 如果当前鼠标位置位于遮罩内，保持遮罩显示
        if (e.y >= 0 && e.y < maskHeight) {
          return;
        } else {
          // 如果鼠标离开的是当前导航项，保持箭头向上
          if (_this2.currentNavItem === e.relatedTarget) {
            return;
          }
          // 根据条件判断是否隐藏遮罩并将箭头设置为向下
          if (!_this2.currentNavItem.subItems) {
            document.getElementById('mask').className = 'mask hide-masktwo';
          } else {
            console.log('遮罩关起来了123');
            _this2.isMaskVisible = false;
            document.getElementById('mask').className = 'mask hide-mask';
            _this2.animationDown = setTimeout(function () {
              if (_this2.$route.name == 'home') {
                _this2.showWhiteImg = true;
                _this2.navConfig.textColor = '#fff';
              }
            }, 500);
          }
        }
      }, 150);
    },
    toPage: function toPage(path) {
      console.log('11', path);
      if (this.$route.fullPath == path) return;
      var loadInstance = _elementUi.Loading.service({
        background: 'rgba(0, 0, 0, 0.5)'
      });
      document.getElementById('mask').className = 'mask hide-mask';
      setTimeout(function () {
        loadInstance.close();
      }, 400);
      this.$router.push({
        path: path
      });
    },
    toItemPage: function toItemPage(link) {
      var loadInstance = _elementUi.Loading.service({
        background: 'rgba(0, 0, 0, 0.5)'
      });
      document.getElementById('mask').className = 'mask hide-mask';
      setTimeout(function () {
        loadInstance.close();
      }, 400);
      if (link.path.indexOf('https:') != -1) {
        return window.open(link.path, '_blank');
      }
      this.$router.push({
        path: link.path,
        query: link.query ? link.query : {},
        params: link.params ? link.params : {}
      });
    },
    // 我要推广的点击事情
    toTg: function () {
      var _toTg = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, param, _yield$apiGetTgData, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              param = {
                // session替换成cookie
                userId: (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).userId : ''
              };
              _context.next = 4;
              return (0, _api.apiGetTgData)(param);
            case 4:
              _yield$apiGetTgData = _context.sent;
              data = _yield$apiGetTgData.data;
              if (data.proRst) {
                that.qrCodetg = data.userImg; //推广码
                that.tgUrl = data.userUrl; //推广链接
              } else {
                this.$message({
                  message: data.proMsg,
                  type: 'error'
                });
              }
              that.dialogTgVisible = true;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function toTg() {
        return _toTg.apply(this, arguments);
      }
      return toTg;
    }(),
    // 登录的点击事件
    clickToLogin: function clickToLogin() {
      this.tabName = 'first';
      this.$root.loginscene = 'HOME_PAGE'; //注册登录场景
      this.$root.dialogFormVisible = true;
    },
    // 退出登录
    toLogoff: function toLogoff() {
      var that = this;
      // session替换成cookie
      (0, _cookie.delCookie)('user');
      (0, _cookie.delCookie)('token');
      that.$root.token = '';
      that.$root.isLogin = false;
      if (that.$route.name == 'pubcars' || that.$route.name == 'pubgoods') {
        that.$root.dialogFormVisible = true;
      }
    }
  }
};